export default __webpack_public_path__ + "media/images/user_photos/112-6d8bfb4b541678dfad340630d456461a.jpg";